import Vue from "vue"
import axios from 'axios'
import auth from './auth'
import store from '../store'
import {ToastProgrammatic as Toast} from 'buefy'
import _ from "lodash";

const get = function (endpoint, params, hideLoad, squashError) {
	if (!store.getters.isLoggedIn) {
		return Promise.reject('user not logged in')
	}
	if (!hideLoad) store.dispatch('startLoading')
	return auth.getAuthHeader(store.state.auth.activeAccountIndex).then(header => {
		return axios.get(endpoint, {
			baseURL: Vue.prototype.$apiUrl,
			params: params,
			headers: {Authorization: header}
		}).then(response => {
			if (!hideLoad) store.dispatch('stopLoading')
			return Promise.resolve(response)
		}).catch(error => {
			if (!hideLoad) store.dispatch('stopLoading')
			if (!squashError) Toast.open(error.response.data.detail || error.response.statusText)
			return Promise.reject(error)
		})
	})
}

const put = function (endpoint, params, hideLoad) {
	if (!store.getters.isLoggedIn) {
		return Promise.reject('user not logged in')
	}
	if (!hideLoad) store.dispatch('startLoading')
	return auth.getAuthHeader(store.state.auth.activeAccountIndex).then(header => {
		return axios.put(endpoint, undefined,{
			baseURL: Vue.prototype.$apiUrl,
			params: params,
			headers: {Authorization: header}
		}).then(response => {
			if (!hideLoad) store.dispatch('stopLoading')
			return Promise.resolve(response)
		}).catch(error => {
			if (!hideLoad) store.dispatch('stopLoading')
			Toast.open(error.response.data.detail || error.response.data.error || error.response.statusText)
			return Promise.reject(error)
		})
	})
}

const post = function (endpoint, data) {
	if (!store.getters.isLoggedIn) {
		return Promise.reject('Not logged in')
	}
	store.dispatch('startLoading')
	return auth.getAuthHeader(store.state.auth.activeAccountIndex).then(header => {
		return axios.post(endpoint, data, {
			baseURL: Vue.prototype.$apiUrl,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': header,
			}
		}).then(response => {
			store.dispatch('stopLoading')
			return Promise.resolve(response)
		}).catch(error => {
			store.dispatch('stopLoading')
			return Promise.reject(error)
		})
	})
}

const destroy = function (endpoint, id) {
	if (!store.getters.isLoggedIn) {
		return Promise.reject('Not logged in')
	}
	store.dispatch('startLoading')
	return auth.getAuthHeader(store.state.auth.activeAccountIndex).then(header => {
		return axios.delete(endpoint + id, {
			baseURL: Vue.prototype.$apiUrl,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': header,
			}
		}).then(response => {
			store.dispatch('stopLoading')
			return Promise.resolve(response)
		}).catch(error => {
			store.dispatch('stopLoading')
			return Promise.reject(error)
		})
	})
}

export default {
	
	getUser(screenName) {
		return get('get-user/', { screen_name: screenName })
	},
	
	getTweet(id) {
		return get('get-tweet/', {id: id})
	},
	
	userSearch(q) {
		return get('search-users/', {q: q}, true)
	},
	
	getFriends() {
		return get('get-friends/', {}, true)
	},
	
	timeline(which, params) {
		if (['home', 'you', 'mentions', 'recent', 'user'].indexOf(which) > -1) {
			return get('timeline/' + which + '/', params)
		} else {
			return Promise.reject('invalid timeline requested')
		}
	},
	
	thread(id, screen_name) {
		return get('get-thread/', {id, screen_name})
	},
	
	linkMeta(url) {
		return get('link-meta/', {url}, true, true)
	},
	
	favoriteCreate(id) {
		return put('favorite/create/', {id})
	},
	favoriteDestroy(id) {
		return put('favorite/destroy/', {id})
	},
	retweetCreate(id) {
		return put('retweet/create/', {id})
	},
	retweetDestroy(id) {
		return put('retweet/destroy/', {id})
	},
	
	setFollow(screen_name, follow) {
		if (follow) {
			return put('relationship/follow/', {screen_name})
		} else {
			return put('relationship/unfollow/', {screen_name})
		}
	},
	
	
	buildThreadPostFormData(data) {
		// blank array for tweets
		data.tweets = []
		
		// get all IDs (may be duplicates) into a single flat array
		let thread_image_ids = store.getters.tweets.map(tweet => tweet.image_ids).flat()
		
		// loop through all images in the store, and if we have that ID in our thread, then
		// append to the form and keep a tally of its index with a separate array
		let formData = new FormData()
		let imageIds = []
		_.toArray(store.state.images.images).forEach(image => {
			if (thread_image_ids.indexOf(image.id) > -1) {
				formData.append('images', image.file)
				imageIds.push(image.id)
			}
		})
		
		// now create each tweet, and create an ID map that matches our formData
		store.getters.tweets.forEach((tweet, tweet_index) => {
			data.tweets.push({
				text: store.getters.fullTweetText(tweet_index),
				quote_tweet: store.getters.getQuoteTweetUrl(tweet_index),
				image_ids: tweet.image_ids.map(val => imageIds.indexOf(val))
			})
		})
		
		// add this data onto our form, and return
		formData.append('data', JSON.stringify(data))
		return formData
	},
	
	postThread(data) {
		return post(`create-thread/`, data)
	},
	
	
	scheduleThread(data) {
		return post('threads/', data)
	},
	
	getOutbox() {
		return get('threads/')
	},
	
	deleteScheduledThread(id) {
		return destroy('threads/', id)
	}
	
}
